export const GRAPHQL_URL = `${window.ENV.HTTP_URL}/cece/graphql`
